module.exports = __webpack_public_path__ + "img/unshare.2d0e992e.svg";